import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import MetaDataService from "../../services/MetaDataService";
import classes from "./premiumPlanFaq.module.css";
import { FAQ } from "../../routes/RouteConstants";
import CustomButton from "../CustomButton";
import CustomAccordian from "../CustomAccordian";
import LogService from "../../services/LogService";
import CREDIT_EVENTS from "../../utils/CreditEvents";

const PremiumPlanFaq = () => {
  const router = useRouter();
  const [faqData, setFaqData] = useState({
    heading: "How can we help you?",
    faqs: []
  });
  const [expanded, setExpanded] = useState("panel0");

  useEffect(() => {
    const getFaq = async () => {
      const data = await MetaDataService.getCreditFaq();
      setFaqData(data.data);
    };
    getFaq();
  }, []);

  function handleChange(id) {
    setExpanded(id === expanded ? "" : id);
  }
  function viewAllFaq() {
    LogService.log(CREDIT_EVENTS.CREDIT_SELECTION_VIEW_ALL_FAQ_CLICKED);
    // Use route constant with hire prefix
    window.open(`/hire${FAQ}`, "_blank");
  }
  const { faqs, heading } = faqData;
  return (
    <div className={classes.faqContainer}>
      <h2 className={classes.heading}>{heading}</h2>
      {faqs.map((f, index) => (
        <CustomAccordian
          summary={f.question}
          details={f.answer}
          key={`faq-${index}`}
          expanded={expanded === `panel${index}`}
          onChange={() => handleChange(`panel${index}`)}
          id={`panel${index}`}
        />
      ))}
      <CustomButton className={classes.faqButton} onClick={viewAllFaq}>
        See All FAQs
      </CustomButton>
    </div>
  );
};
export default PremiumPlanFaq;
